import type { LayoutConfig } from "golden-layout";

export const IndependentLayoutConfig = (
  changeToAdvancedDownload: boolean,
): LayoutConfig => ({
  root: {
    type: "row",
    content: [
      {
        type: "column",
        size: "18%",
        content: [
          {
            type: "component",
            componentType: "queryBuilder",
            title: "Query Builder",
            id: 'query-builder-pane',
            size: "62%",
            minSize: "200px",
            isClosable: true,
            reorderEnabled: true,
          },
          {
            type: "stack",
            size: "38%",
            content: [
              {
                type: "component",
                componentType: "mapSettings",
                title: "Map Settings Pane",
                isClosable: true,
                reorderEnabled: true,
              },
              {
                type: "component",
                componentType: "mapControls",
                title: "Layer List",
                isClosable: true,
                reorderEnabled: true,
              },
            ],
          },
        ],
      },
      {
        type: "column",
        size: "82%",
        content: [
          {
            type: "row",
            size: "62%",
            content: [
              {
                type: "component",
                componentType: "map",
                title: "Map",
                size: "60%",
                minSize: "120px",
                isClosable: true,
                reorderEnabled: true,
              },
              {
                type: "stack",
                size: "40%",
                activeItemIndex: changeToAdvancedDownload ? 1 : 0,
                content: [
                  {
                    type: "component",
                    componentType: "table",
                    title: "Table",
                    minSize: "120px",
                    isClosable: false,
                    reorderEnabled: true,
                  },
                  {
                    type: "component",
                    componentType: "advancedDownload",
                    title: "Advanced Download",
                    minSize: "120px",
                    isClosable: false,
                    reorderEnabled: true,
                  },
                ],
              },
            ],
          },
          {
            type: "row",
            size: "38%",
            content: [
              {
                type: "stack",
                size: "80%",
                content: [
                  {
                    type: "component",
                    componentType: "chart",
                    componentState: {
                      activeTab: "trend",
                    },
                    title: "Trend Chart Over The Years",
                    size: "100%",
                    minSize: "80px",
                    isClosable: true,
                    reorderEnabled: true,
                  },
                  {
                    type: "component",
                    componentType: "chart",
                    componentState: {
                      activeTab: "bar",
                    },
                    title: "Column Chart",
                    size: "100%",
                    minSize: "80px",
                    isClosable: true,
                    reorderEnabled: true,
                  },
                  {
                    type: "component",
                    componentType: "chart",
                    componentState: {
                      activeTab: "advanced",
                    },
                    title: "Advanced Charts",
                    size: "100%",
                    minSize: "80px",
                    isClosable: true,
                    reorderEnabled: true,
                  },
                ],
              },
              {
                type: "component",
                componentType: "legend",
                title: "Legend",
                size: "20%",
                isClosable: false,
              },
            ],
          },
        ],
      },
    ],
  },
  dimensions: {
    borderWidth: 10,
    borderGrabWidth: 18,
    headerHeight: 26,
  },

  settings: {
    constrainDragToContainer: true,
    reorderEnabled: true,
    showPopoutIcon: false,
    showMaximiseIcon: true,
    showCloseIcon: true,
  },

  header: {
    show: "top",
    popout: false,
    maximise: "Maximize pane",
    close: "Close pane",
  },
});
